import React from 'react';
import styles from './Alert.module.scss';
import { Icon } from 'components/ui';
import clsx from 'clsx';

type AlertProps = {
  type: 'error' | 'success';
  children: React.ReactNode;
  className?: string;
};

const Alert: React.FC<AlertProps> = ({ children, type, className }) => {
  const renderSuccessMessage = () => (
    <div className={clsx(styles['error-wrapper'], className)}>
      <div className={styles['message']}>
        <Icon name="success" className={styles['icon-success']} />
        {Array.isArray(children) || typeof children === 'string' ? children : 'Something wrong'}
      </div>
    </div>
  );

  const renderErrorMessage = () => (
    <div className={clsx(styles['success-wrapper'], className)}>
      <div className={styles['message']}>
        <Icon name="error" className={styles['icon-error']} />
        {Array.isArray(children) || typeof children === 'string' ? children : 'Something wrong'}
      </div>
    </div>
  );

  return type === 'success' ? renderSuccessMessage() : renderErrorMessage();
};

export default Alert;
